module.exports = __webpack_public_path__ + "static/media/kayaktres.e0545ac0.png";